module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar image = (helpers.detectRenderedImage(model.image, model._image) || {}).rendered || {};\n%>\n<div>\n<div class=\"image loading\"></div>\n<div class=\"content\">\n<h3><%- image.title || \"\" %></h3>\n<p><%- image.alt || \"\" %></p>\n</div>\n</div>"
  , __filename = "components/templates/sliderGallery/image.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var image = (helpers.detectRenderedImage(model.image, model._image) || {}).rendered || {};

    ; __line = 3
    ; __append("\n<div>\n<div class=\"image loading\"></div>\n<div class=\"content\">\n<h3>")
    ; __line = 7
    ; __append( image.title || "" )
    ; __append("</h3>\n<p>")
    ; __line = 8
    ; __append( image.alt || "" )
    ; __append("</p>\n</div>\n</div>")
    ; __line = 10
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/sliderGallery/image.ejs

}